import React from 'react';
import { Navbar } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Context
import { useAuth } from '../../context/auth';

//Routes
import routes from '../../routes/views.routes';

//Assets
import "../../assets/css/navbar.css"

export default function NavBarAuth() {
    const { session, logoSistemaBranca } = useAuth();
    const navigate = useNavigate();

    //Função executada no clique do item da navbar
    const onClickItem = (route) => {

        if (session == null || session.tipo != "municipe") {
            navigate("/auth/login");
            return;
        }
        navigate(route);
    }

    return (

        <Navbar
            expand="md"
            className='navbar'
        >
            <div className='d-flex align-items-center justify-content-between w-100'>
                <div className='d-flex align-items-center justify-content-between'>
                    {
                        routes.filter(value => value.tipo == "auth").map(value => {
                            return <span className='itemNavBar' onClick={() => onClickItem(value.layout + value.path)}>{value.name}</span>
                        })
                    }

                </div>
            </div>
        </Navbar >
    )
}